<template>
  <div>
    <div class="pa-5 deskripsi">
      <div v-if="items.desc !=null">{{items.desc}}</div>
      <div v-if="items.desc == null">Tidak ada deskripsi</div>
    </div>
    <v-divider></v-divider>
  </div>
</template>
<script>
export default {
  data() {
    return {
      id: this.$route.params.id,
      items: [],
      userid: localStorage.getItem("user_id")
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      fetch(
        "http://meridinet.saebo.id:2082/Login/api/tampil/" +
          this.id +
          "/" +
          this.userid
      )
        .then(response => response.json())
        .then(data => {
          this.items = data;
        });
    }
  }
};
</script>
<style scoped>
.deskripsi {
  white-space: pre;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 90%;
  letter-spacing: 0px;
  word-spacing: 2px;
  color: #78909c;
  font-weight: 400;
  text-decoration: none;
  font-style: normal;
  font-variant: normal;
  text-transform: none;
}
</style>